import { motion } from "framer-motion";
import { useHeroMotion } from "../../hooks/useHeroMotion";
import { HeroWindows } from "./HeroWindows";
import { HeroContent } from "./HeroContent";

export const Hero = () => {
  const { ref, isMobile, opacity, ...windows } = useHeroMotion();
  return (
    <section ref={ref} data-testid="hero-section"
      className="relative flex min-h-[100svh] items-center justify-center overflow-hidden px-5 pt-24">
      <div className="we-glow left-[-8%] top-[10%] h-72 w-72 bg-[#2979FF]" />
      <div className="we-glow right-[-6%] bottom-[6%] h-80 w-80 bg-[#00E5FF]" />
      {!isMobile && <HeroWindows {...windows} />}
      <motion.div style={{ opacity }} className="relative z-10 mx-auto max-w-4xl text-center">
        <HeroContent />
      </motion.div>
    </section>
  );
};